export default __webpack_public_path__ + "static/media/icon1.cb2c8479.svg";